import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { push } from 'connected-react-router';
import { Container, Card, Table, Button, Spinner } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faSearch } from '@fortawesome/free-solid-svg-icons';
import { ORDER_PAY_LIST, TIPO_RECIBO } from 'src/utils/constants';
import { formatterPeso, mFormat, getOrderPayTypeValueToShow, removeDuplicateElements, clearNullValuesFromArr, organismsFilter } from 'src/utils/utils';
import { getOrderPayDetailID, getAffectationsMovementsByIDOrderPayListIsFetching, getOrderPayByIdIsFetching } from 'src/redux/orderPay/orderPayReducer';
import { getAdministrativeServiceByIdData } from 'src/redux/administrativeService/administrativeServiceReducer';
import { tryGetOrganismAdministrativeServices, trySearchAdministrativeServiceById } from '../../../redux/administrativeService/administrativeServiceActionCreator';
import { clearDetailOrderPayData } from 'src/redux/orderPay/orderPayActions';
import { tryOrderPayById } from 'src/redux/orderPay/orderPayActionCreator';
import TableReceiptsGenerator from 'src/components/pages/OrderPay/TableReceiptsGenerator';
import { isNotEmptyArray } from 'src/services/validationService';
import { getGlobalDataPeriodsData } from 'src/redux/globalData/globalDataReducer';
import { setOrderPayToDetail } from '../../../redux/orderPay/orderPayActions';
import ActionIcon from '../../general/ActionIcon';
import DetailModal from '../OrderPay/modal/DetailModal';
import AppLoading from 'src/components/common/AppLoading';
import { getAdministrativeServiceOrganismListData, getAdministrativeServiceOrganismListIsFetching } from 'src/redux/administrativeService/administrativeServiceReducer';
import { useParams } from "react-router-dom";
import { getAccessToken } from 'src/redux/login/loginReducer';
import { fetchChangeState } from 'src/services/orderPayServices';
import { useProfileChecks } from 'src/components/general/menu/hooks/useProfileChecks';
import BeneficiariesTable from "src/components/pages/OrderPay/tables/BeneficiariesTable";
import { getUserData } from 'src/services/userServices';

const OrderPayDetailsPage = () => {

	const { paymentOrderId, serviceId } = useParams();
	const { isProfileNameSA, isProfileNameAI } = useProfileChecks();
	const dispatch = useDispatch();

	const orderPayDetailData = useSelector(state => getOrderPayDetailID(state));
	const orderPayByIdIsFetching = useSelector(state => getOrderPayByIdIsFetching(state));
	const administrativeService = useSelector(state => getAdministrativeServiceByIdData(state));
	const [pedidoFondo, setpedidoFondo] = useState();

	const [admCode, setAdmCode] = useState(orderPayDetailData?.administrativeDocument?.codeOrganism);
	const [admNumber, setAdmNumber] = useState(orderPayDetailData?.administrativeDocument?.number);
	const [admYear, setAdmYear] = useState(orderPayDetailData?.administrativeDocument?.year);

	const periodsData = useSelector(state => getGlobalDataPeriodsData(state))?.data?.sort((a, b) => a.year < b.year ? 1 : -1);

	const OPHaberes = orderPayDetailData?.type == "ORDEN_DE_PAGO_DE_HABERES";
	const OPProveedores = orderPayDetailData?.type == 'ORDEN_DE_PAGO_DE_PROVEEDORES';
	const OPSubsidios = orderPayDetailData?.type == "ORDEN_DE_PAGO_SUBSIDIOS";
	const OPPrestamos = orderPayDetailData?.type == "ORDEN_DE_PAGO_DE_PRESTAMO";
	const OPATN = orderPayDetailData?.type == "ORDEN_DE_PAGO_DE_APORTES_TESORO_NACIONAL";

	const conditionToShowCreditor = orderPayDetailData?.type === 'ORDEN_DE_PAGO_DE_PROVEEDORES';
	const conditionToWage = orderPayDetailData?.type === 'ORDEN_DE_PAGO_DE_HABERES';
	const isWageMultiple = orderPayDetailData?.type === 'ORDEN_DE_PAGO_DE_HABERES_MULTIPLES';
	const isWagesOrder = OPHaberes || isWageMultiple;
	const showObservations = isWagesOrder || OPProveedores || OPSubsidios;

	const [show, setShow] = useState(false);
	const [activeOP, setActiveOP] = useState(false);
	const [activeWageManager, setActiveWageManager] = useState(null);
	const [createdByUser, setCreatedByUser] = useState(null);
	const [lastModifiedUser, setLastModifiedUser] = useState(null);
	const selectedOrderPay = isWageMultiple ? { wageManager: activeWageManager } : orderPayDetailData;

	const affectationsMovementsByIDOrderPayListIsFetching = useSelector(state => getAffectationsMovementsByIDOrderPayListIsFetching(state));

	const administrativeServiceOrganismListIsFetching = useSelector(state => getAdministrativeServiceOrganismListIsFetching(state));
	const organismList = useSelector(state => getAdministrativeServiceOrganismListData(state));
	const accessToken = useSelector(state => getAccessToken(state));

	const matchYearId = (periodsData, year) => {
		return periodsData?.find((a) => a.year === year)?.id
	}

	//grouping of receipts and supplier injection by receipt
	let receiptsCuitArray = [];

	orderPayDetailData?.beneficiaries?.map(beneficiarie => {
		beneficiarie?.receipts?.map(receipt => {
			let receitCuit = {
				...receipt,
				cuit: beneficiarie?.persona?.cuit?.toString(),
				companyName: beneficiarie?.persona?.companyName,
				beneficiaryValidator: beneficiarie?.persona?.beneficiaryValidator,
				providerNumber: beneficiarie?.persona?.providerNumber
			};
			receiptsCuitArray.push(receitCuit);
		});
	});

	useEffect(() => {
		dispatch(clearDetailOrderPayData());
		// const administrativeserviceId = orderPayDetailData.administrativeServiceId
		// dispatch(trySearchAdministrativeServiceById(administrativeserviceId))
		dispatch(trySearchAdministrativeServiceById(serviceId))
		// const afectationsId = orderPayDetailData?.details?.map(order => {
		// 	return order.affectationMovementId
		// });
		// dispatch(tryGetOrganismAdministrativeServices(administrativeserviceId, matchYearId(periodsData, orderPayDetailData?.administrativeDocument?.year)))
		dispatch(tryGetOrganismAdministrativeServices(serviceId, matchYearId(periodsData, orderPayDetailData?.administrativeDocument?.year)))
		// dispatch(tryOrderPayById(orderPayDetailData.id)).then((response) => {
		dispatch(tryOrderPayById(paymentOrderId)).then((response) => {
			response?.legalInstruments?.push(response?.legalInstrument)
			dispatch(setOrderPayToDetail(response));
			setpedidoFondo(response?.fundRequest);
		});
	}, []);

	useEffect(() => {
		if ((isProfileNameSA || isProfileNameAI) && orderPayDetailData && accessToken) {
			const createdById = orderPayDetailData.createdBy;
			const lastModifiedById = orderPayDetailData.lastModifiedBy;
			if (createdById === lastModifiedById && createdById) {
				getUserData(accessToken, createdById)
					.then(response => {
						const userData = response?.data || {
							name: `Usuario ID: ${createdById}`,
							email: 'No disponible'
						};
						setCreatedByUser(userData);
						setLastModifiedUser(userData);
					})
					.catch(error => {
						console.error('Error fetching user data:', error);
						const fallbackData = {
							name: `Usuario ID: ${createdById}`,
							email: 'Error al cargar datos'
						};
						setCreatedByUser(fallbackData);
						setLastModifiedUser(fallbackData);
					});
			} else {
				if (createdById) {
					getUserData(accessToken, createdById)
						.then(response => {
							setCreatedByUser(response?.data || {
								name: `Usuario ID: ${createdById}`,
								email: 'No disponible'
							});
						})
						.catch(error => {
							console.error('Error fetching createdBy user data:', error);
							setCreatedByUser({
								name: `Usuario ID: ${createdById}`,
								email: 'Error al cargar datos'
							});
						});
				}

				if (lastModifiedById) {
					getUserData(accessToken, lastModifiedById)
						.then(response => {
							setLastModifiedUser(response?.data || {
								name: `Usuario ID: ${lastModifiedById}`,
								email: 'No disponible'
							});
						})
						.catch(error => {
							console.error('Error fetching lastModifiedBy user data:', error);
							setLastModifiedUser({
								name: `Usuario ID: ${lastModifiedById}`,
								email: 'Error al cargar datos'
							});
						});
				}
			}
		}
	}, [orderPayDetailData?.createdBy, orderPayDetailData?.lastModifiedBy, accessToken, isProfileNameSA, isProfileNameAI]);

	const onClickBackButton = () => {
		dispatch(push(ORDER_PAY_LIST));
	};

	const onClickDetail = item => {
		setActiveOP(item.paymentOrder);
		setShow(true);
	};

	const onClickWageManagerDetail = item => {
		setActiveWageManager(item);
		setShow(true);
	};

	const handleCloseDetail = () => {
		setShow(false);
		setActiveWageManager(null);
	};

	const calcularTotal = () => {
		let totalLocal = 0;
		orderPayDetailData?.details?.map(item => {
			totalLocal += item?.presupuestoResponse.amount || 0
		});
		return totalLocal;
	};
	let total = calcularTotal();

	const [valueState, setValueState] = useState('');
	const handleChangeValueState = value => setValueState(value);
	const handleChangeOrderPay = (value) => {
		if (!valueState || (orderPayDetailData?.state === valueState)) {
			swal({ text: "Debe seleccionar un estado diferente al actual.", icon: "warning" });
			return;
		}
		swal({
			title: "Confirmación",
			text: `¿Seguro quiere cambiar el estado de la Orden de pago N° ${orderPayDetailData?.number} - ${orderPayDetailData?.year}?`,
			icon: "warning",
			buttons: ["Cancelar", "Aceptar"],
		}).then((willDelete) => {
			if (willDelete) {
				fetchChangeState(accessToken, value.id, valueState).then((response) => {
					if (response) {
						swal("¡Listo!", "El estado de la Orden de Pago ha sido cambiado.", "success");
						dispatch(push(ORDER_PAY_LIST));
					}
				});
			};
		});
	};

	return <>
		<Container fluid>
			<Card className='mb-5'>
				<Card.Header className='h6'>
					Detalle Orden de Pago
				</Card.Header>
				<Card.Body>
					<Table className='text-black-color' striped borderless hover>
						<tbody>
							<tr>
								<td className='text-center font-weight-bold' width='40%'>
									Tipo:
								</td>
								<td className='text-center maxTruncate'>
									{getOrderPayTypeValueToShow(orderPayDetailData?.type)}
								</td>
							</tr>
							<tr>
								<td className='text-center font-weight-bold' width='40%'>
									Servicio:
								</td>
								<td className='text-center maxTruncate'>
									{`${administrativeService?.code} - ${administrativeService?.name}`}
								</td>
							</tr>
							<tr>
								<td className='text-center font-weight-bold' width='40%'>
									Expediente:
								</td>
								<td className='text-center maxTruncate'>
									{orderPayDetailData?.administrativeDocument?.codeOrganism}-{orderPayDetailData?.administrativeDocument?.number} / {orderPayDetailData?.administrativeDocument?.year} - {orderPayDetailData?.administrativeDocument?.title || 'S/D'}
								</td>
							</tr>
							<tr>
								<td className='text-center font-weight-bold' width='40%'>
									Número:
								</td>
								<td className='text-center maxTruncate'>
									{orderPayDetailData?.number} - {orderPayDetailData?.year}
								</td>
							</tr>
							<tr>
								<td className='text-center font-weight-bold' width='40%'>
									Fecha:
								</td>
								<td className='text-center maxTruncate'>
									{mFormat(orderPayDetailData?.datePaymentOrder)}
								</td>
							</tr>
							<tr>
								<td className='text-center font-weight-bold' width='40%'>
									Descripción:
								</td>
								<td className='text-center maxTruncate'>
									{orderPayDetailData?.description}
								</td>
							</tr>
							<tr>
								<td className='text-center font-weight-bold' width='40%'>
									Corresponde a:
								</td>
								<td className='text-center maxTruncate'>
									{orderPayDetailData?.pertainsTo || '-'}
								</td>
							</tr>
							{isWagesOrder &&
								<tr>
									<td className='text-center font-weight-bold' width='40%'>
										Cantidad de Agentes:
									</td>
									<td className='text-center maxTruncate'>
										{orderPayDetailData?.agentsQuantity || '-'}
									</td>
								</tr>
							}
							{showObservations &&
								<tr>
									<td className='text-center font-weight-bold' width='40%'>
										Observaciones:
									</td>
									<td className='text-center maxTruncate'>
										{orderPayDetailData?.observations ? orderPayDetailData?.observations : '-'}
									</td>
								</tr>
							}
							<tr>
								<td className='text-center font-weight-bold' width='40%'>
									Importe:
								</td>
								<td className='text-center maxTruncate'>
									{formatterPeso.format(total)}
								</td>
							</tr>
							{(isProfileNameSA || isProfileNameAI) && createdByUser && (
								<tr>
									<td className='text-center font-weight-bold' width='40%'>
										Creado por:
									</td>
									<td className='text-center maxTruncate'>
										{createdByUser.name} ({createdByUser.email})
										{orderPayDetailData.createdDate && ` - ${mFormat(orderPayDetailData.createdDate)}`}
									</td>
								</tr>
							)}
							{(isProfileNameSA || isProfileNameAI) && lastModifiedUser && (
								<tr>
									<td className='text-center font-weight-bold' width='40%'>
										Último cambio realizado por:
									</td>
									<td className='text-center maxTruncate'>
										{lastModifiedUser.name} ({lastModifiedUser.email})
										{orderPayDetailData.lastModifiedDate && ` - ${mFormat(orderPayDetailData.lastModifiedDate)}`}
									</td>
								</tr>
							)}
							{conditionToWage &&
								<tr>
									<td className='text-center font-weight-bold' width='40%'>
										Liquidación:
									</td>
									<td className='text-center'>
										Consultar detalle de Liquidación &nbsp;
										<ActionIcon className='text-right' toolTipText='Ver detalle' icon={faSearch} onClick={() => onClickDetail(orderPayDetailData)} />
									</td>

								</tr>
							}
						</tbody>
					</Table>

					{isNotEmptyArray(orderPayDetailData?.beneficiaries) && OPProveedores &&
						<>
							<p className='text-black-color h6 mt-4' >
								{TIPO_RECIBO[orderPayDetailData?.beneficiaries?.[0]?.receipts?.[0]?.type]}:
							</p>
							<TableReceiptsGenerator
								receipts={receiptsCuitArray}
								tipo={orderPayDetailData?.beneficiaries?.[0]?.receipts?.[0]?.type}
								orderPayDetailData={orderPayDetailData}
								admCode={admCode}
								admNumber={admNumber}
								admYear={admYear}
								_hookFormMethodsModal={{
									organismList: organismsFilter(organismList)
								}}
							/>
						</>
					}

					{isNotEmptyArray(clearNullValuesFromArr(orderPayDetailData?.legalInstruments)) &&
						<>
							<p className='text-black-color h6 mt-4' >
								Instrumentos Legales:
							</p>
							<Table striped hover size="sm">
								<thead>
									<tr className='text-white-color'>
										<th className='text-center' width="15%">Instrumento</th>
										<th className='text-center' width="15%">Nro.</th>
										<th className='text-center' width="15%">Año</th>
									</tr>
								</thead>
								<tbody className='text-black-color'>
									{removeDuplicateElements(orderPayDetailData?.legalInstruments, "number")?.map((item) => (
										<tr key={item?.number}>
											<td className='text-center maxTruncate'>
												{item?.legalInstrumentType?.name}
											</td>
											<td className='text-center maxTruncate'>
												{item?.number}
											</td>
											<td className='text-center maxTruncate'>
												{item?.year}
											</td>
										</tr>
									))}
								</tbody>
							</Table>
						</>
					}
					{isNotEmptyArray(orderPayDetailData?.beneficiaries) && (OPSubsidios || OPPrestamos || OPATN) &&
						<>
							<BeneficiariesTable
								orderPayDetailData={orderPayDetailData}
								admCode={admCode}
								admNumber={admNumber}
								admYear={admYear}
								_hookFormMethodsModal={{
									organismList: organismsFilter(organismList)
								}}
							/>
						</>
					}

					{isWageMultiple ? (
						<>
							<p className='text-black-color h6 mt-4' >
								Planillas de Liquidación de Haberes:
							</p>
							<Table striped hover responsive>
								<thead>
									<tr>
										<th className='text-center font-weight-bold' width="20%">Número</th>
										<th className='text-center font-weight-bold' width="35%">Descripción</th>
										<th className='text-center font-weight-bold' width="15%">Importe liquido</th>
										<th className='text-center font-weight-bold' width="15%">Importe general</th>
										<th className='text-center font-weight-bold' width="15%">Detalle</th>
									</tr>
								</thead>
								<tbody className='text-black-color'>
									{orderPayDetailData?.wageManagers?.map(item => (
										<tr key={item?.id}>
											<td className='text-center py-1 maxTruncate'>
												{item?.id}
											</td>
											<td className='text-center py-1 maxTruncate'>
												{item?.name}
											</td>
											<td className='text-center py-1 maxTruncate'>
												{formatterPeso.format(item?.netAmount)}
											</td>
											<td className='text-center py-1 maxTruncate'>
												{formatterPeso.format(item?.generalAmount)}
											</td>
											<td className='text-center py-1'>
												<ActionIcon
													className='text-right'
													toolTipText='Ver detalle de Liquidación'
													icon={faSearch}
													onClick={() => onClickWageManagerDetail(item)}
												/>
											</td>
										</tr>
									))}
								</tbody>
							</Table>
						</>) : (orderPayByIdIsFetching) && (
							<div className='text-center'>
								<Spinner animation='border' variant='success' size='sm' />
							</div>
						)}

					<p className='text-black-color h6 mt-4' >
						Afectaciones:
					</p>
					{!affectationsMovementsByIDOrderPayListIsFetching ? (
						<Table striped hover size='sm' responsive>
							<thead>
								<tr>
									<th className='text-center font-weight-bold' width="35%">Nro. Partida</th>
									<th className='text-center font-weight-bold' width="35%">Denominación</th>
									<th className='text-center font-weight-bold' width="20%">Monto</th>
									<th className='text-center font-weight-bold' width="10%">RP</th>
								</tr>
							</thead>
							<tbody className='text-black-color'>
								{
									orderPayDetailData?.details?.map(item => (
										<tr key={item?.presupuestoResponse?.id}>
											<td className='text-center py-1 maxTruncate'>
												<div>{item?.presupuestoResponse?.subCodeCompleteNumber}</div>
											</td>
											<td className='text-center py-1 maxTruncate'>
												{item?.presupuestoResponse?.description}
											</td>
											<td className='text-center py-1 maxTruncate'>
												{formatterPeso.format(item?.presupuestoResponse?.amount)}
											</td>
											<td className='text-center py-1 maxTruncate'>
												<b>{item?.presupuestoResponse?.periodRP}</b>
											</td>
										</tr>
									))
								}
							</tbody>
						</Table>
					) : (
						<div className='text-center'>
							<Spinner animation='border' variant='success' size='sm' />
						</div>
					)}

					{
						pedidoFondo ?
							<>
								<p className='text-black-color h6 mt-4' >
									Pedido de Fondo:
								</p>
								<Table striped borderless hover>
									<thead>
										<tr>
											<th className='text-center font-weight-bold' width="15%">Ejercicio</th>
											<th className='text-center font-weight-bold' width="15%">Número</th>
											<th className='text-center font-weight-bold' width="10%">Fecha</th>
											<th className='text-center font-weight-bold' width="60%">Descripción</th>
										</tr>
									</thead>
									<tbody className='text-black-color'>
										<tr>
											<td className='text-center py-1 maxTruncate'>
												{pedidoFondo?.year}
											</td>
											<td className='text-center py-1 maxTruncate'>
												{pedidoFondo?.number}
											</td>
											<td className='text-center py-1 maxTruncate'>
												{mFormat(pedidoFondo?.fundRequestDate)}
											</td>
											<td className='text-center py-1 maxTruncate'>
												{pedidoFondo?.description}
											</td>
										</tr>
									</tbody>
								</Table>
							</>
							:
							'Sin detalle de un Pedido de Fondo'
					}
					{(isProfileNameSA || isProfileNameAI) &&
						<div className='container-fluid my-5 border border-danger rounded d-flex flex-wrap'>
							<p className='h5 container-fluid text-danger mx-4 mt-3'>
								Estado actual de la orden de pago: {orderPayDetailData?.state}
							</p>
							{!pedidoFondo ?
								<>
									<select
										value={valueState}
										className='mx-4 my-3 form-control form-control-lg border-danger col-3'
										onChange={(e) => handleChangeValueState(e.target.value)}
									>
										<option value={''}>Seleccionar estado</option>
										<option value={'BORRADOR'}>BORRADOR</option>
										<option value={'ACTIVO'}>ACTIVO</option>
										<option value={'ANULADO'}>ANULADO</option>
										<option value={'CONTABILIZADO'}>CONTABILIZADO</option>
										<option value={'OBSERVADO'}>OBSERVADO</option>
										<option value={'COMPLETO'}>COMPLETO</option>
									</select>
									<Button className='mx-4 my-3 btn-danger btn-lg' onClick={() => handleChangeOrderPay(orderPayDetailData)}>
										Cambiar estado
									</Button>
								</>
								: <div className="alert alert-danger border border-danger w-100" role="alert">
									<strong>¡Importante! </strong>Tiene un Pedido de Fondo asociado, no puede cambiar el estado de la Orden de Pago.
								</div>
							}
						</div>
					}
					<div className='container-fluid text-center'>
						<Button className='mx-4 my-3 btn-primary btn-lg' onClick={onClickBackButton}>
							<FontAwesomeIcon icon={faArrowLeft} className='mr-2' />
							Volver
						</Button>
					</div>
				</Card.Body>
			</Card>
		</Container>
		<AppLoading isLoading={(administrativeServiceOrganismListIsFetching && conditionToShowCreditor)} />
		<DetailModal
			showPayOrderDetailModal={show}
			setShowPayOrderDetailModal={handleCloseDetail}
			activePayOrder={activeOP}
			selectedOrderPay={selectedOrderPay}
		/>
	</>
};

export default OrderPayDetailsPage;